import { AlpineComponent } from 'alpinejs';

type AccordionData = {
  scrollToOpenedItem: (item: HTMLElement) => void,
}

export default ():AlpineComponent<AccordionData> => ({
  init() {
    const collapseElements = this.$root.querySelectorAll('.collapse') as NodeListOf<HTMLElement>;
    if (collapseElements) {
      collapseElements.forEach((item: HTMLElement) => {
        item.addEventListener('show.bs.collapse', () => {
          this.$lazyLoad.update();

          setTimeout(() => {
            // need to wait to end of collapse transition
            this.scrollToOpenedItem(item);
          }, 350);
        });
      });
    }
  },

  scrollToOpenedItem(item: HTMLElement) {
    let topOffset: number = 0;

    const header = document.querySelector('.header') as HTMLElement;
    if (header) {
      topOffset = header.clientHeight;
    }

    const previousItem = item.previousElementSibling;
    if (previousItem) {
      const scrollOptions: ScrollIntoViewOptions = {
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      };

      // Calculate the scroll position manually
      const scrollPosition = previousItem.getBoundingClientRect().top + window.scrollY - topOffset;

      // Scroll to the calculated position
      window.scrollTo({
        top: scrollPosition,
        ...scrollOptions,
      });
    }
  }
});
